var store = {};
export var write = function(uid) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (!uid) {
        throw new Error("uid must be given");
    }
    var _o = {};
    _o[uid] = options;
    store = Object.assign(store, _o);
    return store;
};
export var remove = function(uid) {
    if (!uid) {
        throw new Error("uid must be given");
    }
    var _store = Object.assign({}, store);
    _store[uid] = null;
    delete _store[uid];
    store = _store;
};
export default function(uid) {
    if (!uid) {
        throw new Error("uid must be given");
    }
    var _store = Object.assign({}, store);
    return _store[uid];
};
